<template>
	<div class="high-polymer-c" :style="'overflow-x: hidden;background:'+bgColor">
		<div style="width: 1190px;    margin: 0 auto;" >
			<!-- ../assets/images/hechengcailiao_banner.jpg -->
			<div style="width: 1920px;   height: 426px;overflow: hidden; margin-left: -357px;" class="banner-c"><img :src="bannerImage"></div>
		</div>
		<div class="bread-c">
			<div class="item-c">
				<div v-if="lang=='zh'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">首页</div> > 特种氧化铝事业部</div>
				<div v-if="lang=='en'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">home page </div> > Special Alumina Division</div>
				<div v-if="lang=='ko'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">첫 페이지</div> >  특수 산화 알루미늄 사업부</div>
				<div v-if="lang=='ja'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">最初のページ</div> > 特殊アルミナ事業部</div>
			</div>
		</div>
		<div class="info-content">
			<div class="title-c">		
				<div class="title" v-html="detailCompanyInfo.title">
				</div>				
				<div class="line"></div>
			</div>
			<div class="content-c">
				<div v-html="detailCompanyInfo.content"></div>
			</div>
		</div>
		<div class="business-unit-bg">
			<div class="business-unit">
				<div class="title-c">
					<span v-if="lang=='zh'">产品中心</span>
					<span v-if="lang=='en'">Product Center</span>
					<span v-if="lang=='ko'">제품</span>
					<span v-if="lang=='ja'">製品センター</span>
					
					<!-- <template v-if="lang=='zh'">世界一流的树脂材料在我们这里生产</template>
					<template v-if="lang=='en'">World class resin materials are produced here</template>
					<template v-if="lang=='ko'">세계 일류 의 수지 재료 가 우리 에서 생산된다</template>
					<template v-if="lang=='ja'">世界一流の樹脂材料はこちらで生産しています</template> -->
				</div> 
				<!-- :to="{ path:'/businessDetail/'+lang ,query:{ id: business._id}}" -->
				<div  v-for="business in businessList" @click="goDetail(business)" class="business-c f-l" :style="'background:'+(business.bgColor||'#d2e8fc')">
					<div class="image-c">	
						<template v-if="business.icoUrl">
							<img :src="business.icoUrl" >
						</template>
					</div>
					<div class="bottom-c">{{business.productName}}</div>
				</div>
				<div class="clearfix"></div>
				<!-- <div class="content-c" style="margin-bottom:30px">
					<ul>
						<li v-for="business in businessList" @click="goDetail(business)">			
							<div class="title">{{business.productName}}</div>
							<div class="image-c">
								<img :src="business.bannerUrl">
							</div>				
						</li>
						<div class="clearfix"></div>
					</ul>
				</div> -->
				
			</div>
		</div>
		<!-- <div class="content-c" style="margin-bottom:30px">
			<ul>
				<li v-for="business in businessList" @click="goDetail(business)">			
					<div class="title">{{business.productName}}</div>
					<div class="image-c">
						<img :src="business.bannerUrl">
					</div>				
				</li>
				<div class="clearfix"></div>
			</ul>
		</div> -->
		<p-bottom :lang="lang"></p-bottom>
	</div>	
</template>

<script>
export default {
  name: 'SyntheticRawMaterials',
  props:{
	lang:{}
  },
  data() {
	return {
		currentLanguage:'zh',
		businessList:[],
		bannerImage:'',
		imageConfig:{},
		detailCompanyInfo:{},
		bgColor:'#fff'
	}
  },
  methods: {
	async getImage(){
		const res=await this.$http.get('imageConfig')
		this.imageConfig = res.data[0]||{}
		this.bannerImage = this.imageConfig.secondTabBanner
	},
	handelBg(){
		if(localStorage.getItem('backgroudColor')){
			this.bgColor = JSON.parse(localStorage.getItem('backgroudColor')).company2BdColor
		}
	  },
	async fetch(){
		this.businessList=[];
		const res=await this.$http.get('/syntheticMaterialList');
		if(res.status==200){
			res.data.map(function(business){
				if(business.language==this.lang){
					this.businessList.push(business)
				}				
			}.bind(this))
		}	
		this.getCompanyInfo()				  
	},
	async getCompanyInfo(){
		const res  =  await this.$http.post('companyInfoList',{la:this.lang,type:1})
		this.detailCompanyInfo = res.data[0]||{}	
	},
	goDetail(business){
		
		this.$router.push({
			path:'/syntheticRawMaterialsDetail/'+this.lang,
			query:{
			  id:business._id
			}
		}
		)
		//localStorage.setItem('syntheicBusinessDetailData', JSON.stringify({id:business._id}))
	}
  },
  created(){	
	  this.fetch()&&this.getImage()
	  this.handelBg()
  },
  watch: {
			// 如果路由有变化，会再次执行该方法
			"$route": "fetch"
  }
}
</script>

<style>
	.high-polymer-c{
		position: relative;
	}
	.high-polymer-c .bread-c{
		background: #fff;
		border-bottom: 1px solid#f2f2f2;
	}
	.high-polymer-c .bread-c .item-c{
		width: 1190px;
		margin: 0 auto;
		font-size: 16px;
		color: #333;
		height: 48px;
		line-height: 48px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-ms-flex-direction: row;
		flex-direction: row;
	}
	.high-polymer-c .content-c{
		width: 1190px;
		margin: 10px auto 0;
		position: relative;
		z-index: 10;
		height: 210px;
        overflow: hidden
	}
	.high-polymer-c .content-c ul{
		margin-left: 20px;
	}
	.high-polymer-c .content-c ul li{
		width: 270px;
		
		-moz-box-shadow:0px 0px 0px #999999, 1px 2px 4px #999999;
		-webkit-box-shadow:0px 0px 0px #999999, 1px 2px 4px #999999;
		box-shadow:0px 0px 8px #999999, 3px 2px 2px #999999;
		padding: 15px;
		float: left;
		margin: 10px;
		cursor: pointer;
	}
	.high-polymer-c .content-c ul li:hover{
		background: #d9eaf7;
	}
	.high-polymer-c .content-c ul li .title{
		font-size: 16px;
		font-weight: 600;
		margin:  0px 0 10px 0;
		color:#333
	}
	.high-polymer-c .content-c ul li .image-c{
		width: 233px;
		height: 126px;
		overflow: hidden;
	}
	.high-polymer-c .content-c ul li .image-c img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
</style>
